import React from 'react';
import { Dropdown } from 'antd';
import { useNavigate } from 'react-router-dom';
import Setting from '../../../../assets/Setting.jsx';
import CandleIcon from '../../../../assets/user/CandleIcon.jsx';

export default function AccountCard({ account, items, allitem, onAccountSelect }) {
  const navigate = useNavigate();

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg font-bold text-gray-800">Login: {account?.login}</h3>
            {account?.status}
          </div>
          <p className="text-sm text-gray-500">{account?.createdAt}</p>
        </div>
        {/* Action Buttons */}
        <div className="flex items-center gap-3">
          {account?.originalStatus === 'Approved' && (
            <Dropdown
              menu={{ items: account.isDemo === true ? items : allitem }}
              placement="bottomLeft"
              arrow
              trigger={['click']}
            >
              <div onClick={() => onAccountSelect(account)} className='cursor-pointer'>
                <Setting />
              </div>
            </Dropdown>
          )}
          <button onClick={() => navigate(`/accounts/${account?.login}`)}>
            <CandleIcon />
          </button>
        </div>
      </div>

      {/* Account Details Grid */}
      <div className="grid grid-cols-2 gap-3">
        <div>
          <p className="text-md text-gray-500 mb-1">Platform</p>
          <p className="text-sm font-semibold text-gray-800">{account?.platform || '-'}</p>
        </div>
        <div>
          <p className="text-md text-gray-500 mb-1">A/C Type</p>
          <p className="text-sm font-semibold text-gray-800">{account?.acType || '-'}</p>
        </div>
        <div>
          <p className="text-md text-gray-500 mb-1">Balance</p>
          <p className="text-sm font-semibold text-gray-800">{account?.balances || '-'}</p>
        </div>
        <div>
          <p className="text-md text-gray-500 mb-1">Leverage</p>
          <p className="text-sm font-semibold text-gray-800">{account?.leverage ? `1:${account.leverage}` : '-'}</p>
        </div>
        <div>
          <p className="text-md text-gray-500 mb-1">Currency</p>
          <p className="text-sm font-semibold text-gray-800">{account?.currency || '-'}</p>
        </div>
      </div>
    </div>
  );
}

